export const convertFloorNumber = (num, lastNum) => {
  if (num === 1) {
    return 'first';
  }
  if (num === 2) {
    return 'second';
  }
  if (num === lastNum) {
    return 'last';
  }

  return 'other';
};

export const convertRoomsCount = count => {
  if (!isNaN(count)) {
    return count < 4 ? count : 4; // число roomsCount не может быть больше 4
  }

  return count;
};

export const convertHouseId = address => {
  if (Array.isArray(address)) {
    const houseItem = address.find(item => item.type === 'house');
    if (angular.isObject(houseItem) && houseItem.hasOwnProperty('id')) {
      return houseItem.id;
    }
  }
};
